/* ============ MAIN JS ENTRY ============
 * Bundled and fingerprinted by scripts/build-assets.mjs. Shared across every
 * page, so each module below must no-op gracefully on pages without its
 * relevant markup — e.g. only the home page has hero/mood markup, but the
 * cookie banner (via layout()) and [data-reveal] targets are on every page,
 * and this file loads everywhere.
 */

import { initHeroLight } from './hero-light.js';
import { initScrollMood } from './scroll-mood.js';
import { initReveal } from './reveal.js';
import { initWorkIndex } from './work-index.js';
import { initCookieConsent } from './cookie-consent.js';

function init() {
  initHeroLight();
  initScrollMood();
  initReveal();
  initWorkIndex();
  initCookieConsent();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
